export const useGeneralLayoutProp = () => {}